/* PhoneModelRenderer.js */

"use strict";

const _ = require("lodash");

class PhoneModelRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("phone-model-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("PhoneModel", (this._onPhoneModel = this._onPhoneModel.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("PhoneModel");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setPhoneModel(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onPhoneModel(newVal) {
        this._setPhoneModel(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setPhoneModel(pid) {
        const context = this._model.getContext();
        const detectedPhoneModels = _.get(context, "detectedPhoneModels", {});

        // Find the model name by matching the PID
        let modelName = "";
        for (const [model, modelData] of Object.entries(detectedPhoneModels)) {
            if (modelData.pid === pid) {
                modelName = model;
                break;
            }
        }

        this._rootElem.innerHTML = modelName || pid || "";
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = PhoneModelRenderer;
